import * as React from "react";
import { List } from "../../list/list/list.mjs";
import { Notification } from "../../notification/notification.mjs";
import { NotificationListItem } from "../notification-list-item/notification-list-item.mjs";
const NotificationList = (props) => {
  const { items, children, className } = props;
  const BEM = () => {
    const classArray = ["notification-list"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement(List, { className: BEM(), type: "unstyled", fullWidth: true }, items ? items.map((item) => {
    return /* @__PURE__ */ React.createElement(NotificationListItem, { key: item.id }, /* @__PURE__ */ React.createElement(Notification, { ...item }));
  }) : children);
};
export {
  NotificationList
};
